import React, { useEffect, useState } from 'react';
import { NFT, formatsMarketplaceNft } from './nft-types';
import Image from 'next/image';
import {
  useGetAssetVideoUrlByMetaOgMutation,
  useGetAssetVideoUrlByHtmlMutation,
  useGetAssetInfoLazyQuery,
} from '@src/components/generated/graphql';
import styles from './nft-assets-card.module.css';

type Props = {
  nft: NFT['marketplace'];
  callback: Function;
};

const MarketplaceNFTCard: React.FC<Props> = (props) => {
  const { nft, callback } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [getUrl] = useGetAssetVideoUrlByMetaOgMutation();
  const [getUrlByHTML] = useGetAssetVideoUrlByHtmlMutation();
  const [getOzoneNft] = useGetAssetInfoLazyQuery();

  useEffect(() => {
    (async function () {
      if (nft?.isOzone) {
        setLoading(true);
        setError(false);
        const res = await getOzoneNft({
          variables: {
            where: {
              assetId:
                nft?.id === '21' || nft.id === '20' ? 510 : Number(nft?.id),
            },
          },
        });
        setLoading(false);

        const asset = res.data?.getAssetInfo.asset;
        if (asset) {
          nft.fileIPFS = asset.assetURL;
          nft.previewImage = asset.previewImage;
          nft.format = asset.fileType as any;
        } else {
          setError(true);
        }
      }
    })();
  }, [nft]);

  const loadAsset = async (type: NFT['marketplace']['format']) => {
    if (nft?.isExternal && nft?.externalUrl) {
      let url;
      if (nft?.isUFC) {
        const res = await getUrlByHTML({
          variables: {
            url: nft?.externalUrl,
            type: 'UFC',
          },
        });
        if (res.data?.getAssetVideoUrlByHtml.status === 'success') {
          url = res.data?.getAssetVideoUrlByHtml.url;
        }
      } else if (nft?.isLALIGA) {
        const res = await getUrlByHTML({
          variables: {
            url: nft?.externalUrl,
            type: 'LALIGA',
          },
        });
        if (res.data?.getAssetVideoUrlByHtml.status === 'success') {
          url = res.data?.getAssetVideoUrlByHtml.url;
        }
      } else if (nft?.isNFL) {
        const res = await getUrlByHTML({
          variables: {
            url: nft?.externalUrl,
            type: 'NFL',
          },
        });
        if (res.data?.getAssetVideoUrlByHtml.status === 'success') {
          url = res.data?.getAssetVideoUrlByHtml.url;
        }
      } else {
        const res = await getUrl({
          variables: {
            url: nft?.externalUrl,
          },
        });
        if (res.data?.getAssetVideoUrlByMetaOG.status === 'success') {
          url = res.data?.getAssetVideoUrlByMetaOG.url;
        }
      }

      return callback(nft.name, url, formatsMarketplaceNft[type]);
    }

    return callback(nft.name, nft.fileIPFS, formatsMarketplaceNft[type]);
  };

  if (error || loading) {
    return <></>;
  }

  return (
    <div className={styles.card} onClick={() => loadAsset(nft.format)}>
      <Image
        className={styles.previewImage}
        src={nft.previewImage}
        width={240}
        height={200}
        alt={'NFT image'}
      />
      <span className={styles.name}>{nft.name}</span>
    </div>
  );
};

export default MarketplaceNFTCard;
